// Shared between Profiles.jsx (the card grid) and ProfileDetail.jsx (the
// full detail page) so both agree on the same status colors/labels.

export const AADHAR_STATUS_META = {
    approved: { label: 'Approved', color: '#2E7D32', bg: '#E8F5E9' },
    pending: { label: 'Pending review', color: '#7A5C00', bg: '#FFF8E1' },
    rejected: { label: 'Rejected', color: '#B71C1C', bg: '#FDECEC' },
};

export const aadharStatusMeta = status =>
    AADHAR_STATUS_META[status] || { label: 'Not submitted', color: 'var(--admin-text-muted)', bg: 'var(--admin-surface-muted)' };

// First letter of whatever name is available — the initials-avatar fallback
// used wherever a profile has no uploaded photo.
export const initialFor = name => (name || '?').trim().charAt(0).toUpperCase() || '?';

export const mediaUrl = path => {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    const base = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';
    return `${base}${String(path).startsWith('/') ? '' : '/'}${path}`;
};
